import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import {createRequestOption} from '../../../shared-libs/util/request-util';

import {environment} from '../../../../../environments/environment';
import {ProfileService} from '../../../shared-libs/service/profile.service';
import {TemplateHtmlDTO} from '@tj/tj-dmp-lib-api';

type EntityResponseType = HttpResponse<TemplateHtmlDTO>;
type EntityArrayResponseType = HttpResponse<TemplateHtmlDTO[]>;

@Injectable({providedIn: 'root'})
export class TemplateHtmlService {
    public resourceUrl = environment.SERVER_API_URL + 'services/configurator/api/template-html';

    constructor(
        protected http: HttpClient,
        protected profileService: ProfileService) {
    }

    private getHeader(datastore?: string): HttpHeaders {
        let headers = new HttpHeaders();
        if (datastore == null) {
            datastore = String(this.profileService.getDatastore());
        }
        headers = headers.set('X-DataStoreID', datastore);
        return headers;
    }

    create(templateHtml: TemplateHtmlDTO): Observable<EntityResponseType> {
        return this.http.post<TemplateHtmlDTO>(this.resourceUrl, templateHtml, {observe: 'response', headers: this.getHeader()});
    }

    update(templateHtml: TemplateHtmlDTO): Observable<EntityResponseType> {
        return this.http.put<TemplateHtmlDTO>(this.resourceUrl, templateHtml, {observe: 'response', headers: this.getHeader()});
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<TemplateHtmlDTO>(`${this.resourceUrl}/${id}`, {observe: 'response', headers: this.getHeader()});
    }

    findByTag(tags: Array<string>): Observable<EntityArrayResponseType> {
        const params = {
            tags: tags
        };
        return this.http.get<TemplateHtmlDTO[]>(`${this.resourceUrl}/find`, {
            observe: 'response',
            headers: this.getHeader(),
            params: params
        });
  }

  query(req?: any, datastore?:string): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
      return this.http.get<TemplateHtmlDTO[]>(this.resourceUrl, {params: options, observe: 'response', headers: this.getHeader(datastore)});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response', headers: this.getHeader() });
  }
}
